module.exports = __webpack_public_path__ + "img/aichi.fe67851f.png";